<style scoped>
.main-title {
  margin-top: 3rem;
  margin-bottom: 1rem;
  line-height: 32pt;
  font-size: 32pt !important;
  font-weight: 600;
}
.input-group-text {
  background-color: #ebebed;
  border: 1px solid #ebebed;
}
.bg-pmse {
  background-color: #e6fff9;
  background-image: url("../../../../public/img/pmse/background.jpg");
  padding-bottom: 6rem;
  clip-path: ellipse(105% 100% at 50% 0%);
}
input[type="text"] {
  border: 1px solid #ebebed;
}
.button-login > .btn-success {
  width: 120px;
  background-color: #09cc9a;
  border: 1px solid #09cc9a;
  margin-right: 0.5rem;
  border-radius: 1rem !important;
}

.button-login > .btn-outline-success {
  width: 120px;
  border: 1px solid #09cc9a;
  margin-right: 0.5rem;
  border-radius: 1rem !important;
}
canvas {
  pointer-events: none;
}
.error-message {
  padding: 0.25rem;
  color: #fff;
  background-color: #ff6884;
  border-radius: 5px !important;
  text-align: center;
  font-size: 10pt;
}

.btn-sso {
  background-color: #fff;
  color: #09cc9a;
  border: 1px solid #09cc9a !important;
}

.mt-10 {
  margin-top: 12rem !important;
}
</style>
<template>
  <div>
    <b-container fluid class="bg-pmse">
      <b-container class="pt-1">
        <b-row>
          <b-col>
            <b-row
              class="mt-10"
              v-if="this.$store.getters['auth/isAuthenticated']"
            >
              <div
                v-if="!completeProfile && this.user.role.includes('ROLE_PPMSE')"
              >
                <b-alert variant="warning" show>
                  <span>
                    Anda belum melakukan pembaruan profil, silakan lengkapi
                    profil Anda
                    <b-link :to="'/pmse/ubah-profil'">disini</b-link>.
                  </span>
                </b-alert>
              </div>
              <div
                v-if="
                  !approved &&
                  completeProfile &&
                  rejected &&
                  this.user.role.includes('ROLE_PPMSE')
                "
              >
                <b-alert variant="warning" show>
                  <span>
                    Profil Anda telah direject oleh admin, silakan perbaiki
                    profil Anda
                    <b-link :to="'/pmse/ubah-profil'">disini</b-link>.
                  </span></b-alert
                >
              </div>
              <div
                v-if="
                  !approved &&
                  completeProfile &&
                  !rejected &&
                  this.user.role.includes('ROLE_PPMSE')
                "
              >
                <b-alert variant="warning" show
                  >Profil Anda belum di-approve, tim BPS akan memeriksa profil
                  Anda. Jika ada pertanyaan, silakan hubungi admin.</b-alert
                >
              </div>
            </b-row>
            <legend class="main-title text-white">
              Portal Penyampaian Data dan Informasi
              <span style="color: #09cc9a">PMSE</span>
            </legend>
            <p class="text-white">
              Kemajuan ekonomi digital Indonesia sangat bergantung pada
              kebijakan pembangunan berbasis data yang akurat. Berdasarkan
              Peraturan Pemerintah No. 80 Tahun 2019 tentang Perdagangan Melalui
              Sistem Elektronik (PMSE), Badan Pusat Statistik (BPS) diamanahkan
              untuk merekam data PMSE di Indonesia. Kami mengundang partisipasi
              Anda untuk berkolaborasi merajut data PMSE Indonesia!
            </p>
            <b-row
              class="mt-4 mb-4"
            >
            
              <b-col col lg="10">
                
                <p class="error-message" v-if="error">{{ error }}</p>
                <ValidationObserver v-slot="{ passes }">
                  <BTextInputWithValidation
                    rules="required"
                    type="text"
                    icon="person"
                    name="Username/Email"
                    v-model="username"
                    placeholder="Username/Email"
                  />
                  <BPasswordInputWithValidation
                    rules="required"
                    type="password"
                    icon="person"
                    name="Password"
                    v-model="password"
                    placeholder="Password"
                  />
                  <b-button
                    variant="success"
                    class="w-100"
                    @click="passes(login2)"
                    >Masuk</b-button
                  >
                </ValidationObserver>
                <b-row>
                  <b-col>
                    <p style="margin-top: 10px" class="text-white">
                      Lupa password? <a href="https://pmse.bps.go.id/auth/forgot">Klik di sini</a>
                    </p>
                  </b-col>
                  <b-col>
                    <p style="margin-top: 10px" class="text-white">
                      Belum punya akun? <a href="https://pmse.bps.go.id/auth/register">Daftar di sini</a>
                    </p>
                  </b-col>
                </b-row>
              </b-col>

              
              <!-- <b-col cols="4"> </b-col> -->
            </b-row>
            <span class="mt-3 p-3" style="margin-top: 40px;background-color: #419469;color:white;">
              Video Tutorial penyampaian data PMSE dapat diakses melalui link <a href="https://s.id/video-pmse" target="_blank" style="color:yellow;">berikut</a>
            </span>
          </b-col>
          <b-col style="vertical-align: middle; display: inline-flex">
            <b-img
              style="margin-top: 5rem"
              v-bind="mainProps"
              src="/img/pmse/wallpaper.png"
              fluid
              alt="PMSE Landing Page"
            ></b-img>
          </b-col>
        </b-row>
      </b-container>
      <!-- <b-modal
        id="modal-forgot"
        scrollable
        title="Lupa Password?"
        hide-footer
        @show="resetModal"
        @hidden="resetModal"
      >
        <b-container class="py-1">
          <p>
            Silakan masukkan email Anda. Kami akan mengirimkan Email berisi
            tautan untuk membuat password baru.
          </p>
          <BTextInputWithValidation
            ref="emailState"
            rules="required|email"
            type="email"
            icon="envelope-open"
            name="email"
            v-model="email"
            placeholder="Email"
          />
          <p style="text-align: end">
            <b-button
              class="mb-3"
              size="sm"
              variant="success"
              @click="handleOk($event)"
            >
              Reset Password
            </b-button>
          </p>
        </b-container>
      </b-modal> -->
    </b-container>

    <b-container
      v-if="!this.$store.getters['auth/user'].role.includes('ROLE_SUPERADMIN')"
    >
      <!-- <data-collection />
      <faq />
      -->
    </b-container>
    <b-modal
      id="modal-xl"
      size="large"
      hide-footer
      hide-header
      title="Alur Penyampaian "
    >
      <b-carousel
        v-model="slide"
        :interval="5000"
        controls
        indicators
        img-width="1024"
        img-height="480"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!--<b-carousel-slide img-src="/file/pmse/Poster Penyampaian Data PMSE Q1 2024.png">
        </b-carousel-slide>-->
        <b-carousel-slide
          img-src="/file/pmse/Alur Penyampaian Data dan Informasi PMSE.jpg"
        >
          <!-- <b-img
          fluid-grow
          alt="Fluid-grow image"
          ></b-img> -->
        </b-carousel-slide>
      </b-carousel>
    </b-modal>
  </div>
</template>

<script>
import config from "@/appConfig";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import { ValidationObserver } from "vee-validate";
import BTextInputWithValidation from "@/components/inputs/BTextInputWithValidation";
import BPasswordInputWithValidation from "@/components/inputs/BPasswordInputWithValidation";
// import DataCollection from "./DataCollection.vue";
// import Faq from  ` "./FAQ.vue";
import PmseService from "../../../services/PmseService";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";
// import { VueRecaptcha } from "vue-recaptcha";

// Vue.use(VueReCaptcha, { siteKey: '6LdU7ZYpAAAAAGHCAWSbCR1KQG54LaylSbQ9dMh-' })

export default {
  name: "HalamanAwalPmse",
  components: {
    ValidationObserver,
    BTextInputWithValidation,
    BPasswordInputWithValidation,
    // DataCollection,
    // Faq,
    // VueRecaptcha,
  },
  data: () => {
    return {
      // recaptcha: null,
      slide: 0,
      sliding: null,
      code: "",
      captcha: "",
      response: "",
      error: null,
      username: null,
      password: null,
      email: "",
      emailState: null,
      showpassword: false,
      mainProps: {
        fluidGrow: true,
      },
      // completeProfile: false,
      // approved: false,
    };
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 1;
  },
  mounted() {
    // console.log('sdsjhdshdgsgh')
    this.loadRecaptha();
    this.$bvModal.show("modal-xl");
    document.body.scrollTop = document.documentElement.scrollTop = 1;
    // this.createCaptcha()
    const qs = window.location.search.substring(1).split("&");
    const params = {};
    for (let i = 0; i < qs.length; i++) {
      const a = qs[i].split("=");
      params[a[0]] = a[1];
    }
    if (params["code"] != undefined) {
      this.showLoading(1000);
      this.$store
        .dispatch("auth/loginSso", {
          code: params["code"],
          redirectUrl:
            window.location.protocol +
            "//" +
            window.location.host +
            process.env.VUE_APP_PUBLIC_PATH +
            "/pmse?redirect=" +
            params["redirect"],
        })
        .then(() => {
          if (this.$store.getters["auth/isAuthenticated"]) {
            Swal.close();
            this.$router.push("/pmse");
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            Swal.fire({
              icon: "error",
              title: "Server Error",
              text: "Tidak dapat terhubung ke server aplikasi, silahkan hubungi admin",
            });
          } else if (err.response.status == 400) {
            Swal.fire({
              icon: "error",
              title: "Login SSO Error",
              text: "Token SSO sudah kadaluarsa, Silahkan login ulang kembali",
              showCloseButton: true,
              showCancelButton: true,
            }).then((res) => {
              if (res.value) {
                this.loginSso();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Login SSO Error",
              text: "Maaf Anda tidak terdaftar sebagai user pada website ini. Silahkan menghubungi Direktorat SIS atau Direktorat Neraca Pengeluaran jika Anda ingin melanjutkan.",
              showCloseButton: true,
              showCancelButton: false,
            }).then(() => {
              this.$router.push("/pmse");
            });
          }
          console.log(err.response);
        });
    }
    if (this.$store.getters["auth/isAuthenticated"]) {
      if (this.user.role.includes("ROLE_SUPERADMIN")) {
        this.approved = true;
        this.completeProfile = true;
      } else {
        this.loadDataPerusahaan();
        this.completeProfile = this.$store.getters["auth/user"].isApproved;
        this.approved = this.dp.isApproved;
      }
    }
  },
  methods: {
    async loadRecaptha() {
      await this.$recaptchaLoaded();
    },
    async login2() {
      Swal.fire({
        title: "Processing",
        text: "Sedang memproses login...",
        icon: "info",
        allowOutsideClick: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        onBeforeOpen: async () => {
          Swal.showLoading();
          try {
            const token = await this.$recaptcha("Login");
            const response = await axios.post(
              "https://pmse-api.bps.go.id/auth/login-indah",
              {
                email: this.username,
                password: this.password,
                token,
              }
            );
            const code = response.data.code;
            window.location.replace("https://pmse.bps.go.id?code=" + code);
          } catch (e) {
            Swal.fire({
              title: "Error",
              text: e.toString(),
              icon: "error",
            });
          }
        },
      });

      // console.log(token)
    },
    openPMSE() {
      window.open("https://pmse.bps.go.id", "_self");
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    // renderCaptcha: function() {
    //   this.recaptcha = new VueRecaptcha(op)
    // },
    onVerify: function (response) {
      this.response = response;
      // console.log(response);
      // console.log(this.$refs.grecaptcha)
    },
    resetModal() {
      this.email = "";
      this.emailState = null;
    },
    handleOk(bvModalEvent) {
      const provider = this.$refs["emailState"].$children[0];
      bvModalEvent.preventDefault();
      provider.validate().then((result) => {
        if (result.valid) {
          Swal.fire({
            title:
              "Apakah Anda yakin ingin mereset akun Portal Penyampaian Data dan Informasi PMSE yang didaftarkan dengan email ini?",
            // text:
            //   "Password lama tidak akan berlaku apabila anda tetap melanjutkan.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ya",
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.fire({
                title: "Mohon Tunggu !",
                html: "Processing...",
                icon: "info",
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                  Swal.showLoading();
                },
              });
              PmseService.forgotPassword({ email: this.email }).then(
                () => {
                  Swal.close();
                  Swal.fire(
                    "Berhasil!",
                    "Silakan periksa email anda!",
                    "success"
                  );
                },
                (error) => {
                  console.log(error);
                  Swal.close();
                  Swal.fire(
                    "Gagal",
                    "Cek kembali email yang anda masukkan!",
                    "error"
                  );
                }
              );
              this.$nextTick(() => {
                this.$bvModal.hide("modal-forgot");
              });
            }
          });
        } else {
          this.$bvToast.toast("Silakan perbaiki terlebih dahulu.", {
            title: `Format email anda salah! `,
            variant: "danger",
            solid: true,
          });
        }
      });
    },
    loginSso: function () {
      const authServerUrl = "https://sso.bps.go.id/auth";
      const realm = "pegawai-bps";
      const clientId = config.SSO_CLIENT_ID;
      let redirectUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        process.env.VUE_APP_PUBLIC_PATH +
        "/pmse?redirect=";

      let historyUrl = this.$router.history._startLocation.replace("/", "");
      if (!historyUrl.includes("pmse")) {
        redirectUrl = redirectUrl + historyUrl;
      }

      const state = "abcdefghij";
      const url =
        authServerUrl +
        "/realms/" +
        realm +
        "/protocol/openid-connect/auth?" +
        "scope=name,email" +
        "&response_type=code" +
        "&client_id=" +
        clientId +
        "&redirect_uri=" +
        redirectUrl +
        "&state=" +
        state;
      window.location.replace(url);
    },
    createCaptcha() {
      if (!this.$store.getters["auth/isAuthenticated"]) {
        document.getElementById("captcha").innerHTML = "";
        var charsArray =
          "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
        var lengthOtp = 7;
        var captcha = [];
        for (var i = 0; i < lengthOtp; i++) {
          var index = Math.floor(Math.random() * charsArray.length + 1);
          if (captcha.indexOf(charsArray[index]) == -1)
            captcha.push(charsArray[index]);
          else i--;
        }

        var color = ["#ff646c", "#24cf5f", "#1d5eff", "#fdab49"];

        var canv = document.createElement("canvas");
        canv.id = "captcha";
        canv.width = 180;
        canv.height = 50;
        var ctx = canv.getContext("2d");
        ctx.font = "35px Georgia";
        ctx.textAlign = "center";
        ctx.strokeStyle = color[Math.floor(Math.random() * color.length)];
        ctx.strokeText(captcha.join(""), 90, 35);

        this.code = captcha.join("");
        document.getElementById("captcha").appendChild(canv);
      }
    },
    validateCaptcha() {
      if (this.captcha == this.code) {
        this.login();
      } else {
        this.error = "Kode captcha tidak sesuai";
        this.createCaptcha();
      }
    },
    async login() {
      Swal.fire({
        title: "Sedang menyiapkan data !",
        icon: "info",
        allowOutsideClick: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await this.$store
          .dispatch("auth/loginPMSE", {
            username: this.username,
            password: this.password,
            captchaResponse: this.response,
          })
          .then(
            () => {
              if (this.$store.getters["auth/isAuthenticated"]) {
                Swal.close();
                this.$router.go();
              }
            },
            (error) => {
              Swal.close();
              this.$refs.grecaptcha.reset();
              this.captcha = "";
              // console.log(error.response.data)
              let errors = error.response.data.errors || null;
              // console.log(errors)
              if (errors != null) {
                this.error = errors.map((e) => e.defaultMessage).join(";");
              } else this.error = error.response.data.message;
              // console.log(this.error)
            }
          );
      } catch (error) {
        console.log(error);
        Swal.close();
        let errors = error.response.data.errors | null;
        if (errors != null) {
          this.error = errors.map((e) => e.defaultMessage).join(";");
        } else this.error = error.response.data.message;
      }
    },
    register() {
      this.$router.push({ name: "PMSERegister" });
    },
    loadDataPerusahaan() {
      PmseService.getSelfProfil().then(
        (response) => {
          this.$store.dispatch("pmse/setDataPerusahaan", response.data);
        },
        (error) => {
          console.log(error);
        }
      );
    },
    showLoading(time) {
      Swal.fire({
        title: "Sedang menyiapkan data !",
        timer: time,
        icon: "info",
        allowOutsideClick: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      dpFromStore: "pmse/getDataPerusahaan",
      userFromStore: "auth/user",
    }),
    user: {
      get() {
        return this.userFromStore;
      },
      set() {},
    },
    dp: {
      get() {
        return this.dpFromStore;
      },
      set(dp) {
        this.$store.dispatch("pmse/setDataPerusahaan", dp);
      },
    },
    completeProfile: {
      get() {
        return this.$store.getters["auth/user"].isApproved;
      },
      set() {},
    },
    approved: {
      get() {
        return this.dp.isApproved == 1;
      },
      set() {},
    },
    rejected: {
      get() {
        return this.dp.isApproved == 2;
      },
      set() {},
    },
  },
};
</script>
